import {useAnalytics} from "lib/hooks";

export default function Analytics() {
  useAnalytics();

  return null;
}
